<!-- ********************  DATA LISTs ******************  -->

<section>

  <datalist id="listCentroCustos">
    <select>
      <option *ngFor="let item of centrosDeCusto" [value]="item.nome"></option>
    </select>
  </datalist>


</section>


<div class="row">
  <div class="col">
    <div class="main-card mb-3 card">
      <div class="card-body">

        <form novalidate [formGroup]="form" (validSubmit)="submit()">

          <input class="form-control text-center" formControlName="id" type="text" hidden>

          <div class="form-row">
            <div class="col-md-2">
              <div class="position-relative form-group">
                <label for="id">Nº</label>
                <input class="form-control text-center" type="text"
                  value="{{ form?.controls['id'].value | zerosEsquerda : 5 }}" disabled readonly>
              </div>
            </div>

            <div class="col-md-6">
              <div class="position-relative form-group">
                <label for="requisitante">Requisitante<span class="field-required">(*)</span></label>
                <input class="form-control" formControlName="requisitante" type="text" maxlength="20" value=""
                  id="requisitante"
                  [ngClass]="{'h-error' : this.form.get('requisitante').hasError('isNotValidRequisitante')}">
                <small *ngIf="form.get('requisitante').hasError('isNotValidRequisitante')"
                  class="form-text text-danger pl-2">
                  O valor deve ser informado
                </small>
              </div>
            </div>
            <div class="col-md-4">
              <div class="position-relative form-group">
                <label for="contato">Ramal<span *ngIf="this.requeridoRamalCentroCusto"
                    class="field-required">(*)</span></label>
                <input class="form-control" formControlName="contato" type="text" maxlength="40" value="" digitOnly
                  [ngClass]="{'h-error' : this.form.get('contato').hasError('isNotValidRamal')}">
                <small *ngIf="form.get('contato').hasError('isNotValidRamal')" class="form-text text-danger pl-2">
                  O valor deve ser informado
                </small>

              </div>


            </div>

          </div>

          <div class="form-row">

            <div class="col">
              <div class="position-relative form-group">
                <label for="servico">Serviço Solicitado<span class="field-required">(*)</span></label>
                <textarea rows="7" class="form-control text-uppercase" formControlName="servico" value=""
                  maxlength="300" style="resize: none;"
                  [ngClass]="{'h-error' : this.form.get('servico').hasError('isNotValidServico')}"></textarea>
                <small *ngIf="form.get('servico').hasError('isNotValidServico')" class="form-text text-danger pl-2">
                  O valor deve ser informado
                </small>


              </div>
            </div>

          </div>

          <div class="form-row">

            <div class="col-md-5">

              <div class="form-group">
                <label for="centroDeCusto">{{labelCentroCusto}}<span *ngIf="this.requeridoRamalCentroCusto"
                    class="field-required">(*)</span></label>

                <div class="input-group">
                  <input type="text" class="form-control" list="listCentroCustos" formControlName="datalistCentroCustos"
                    (change)="changeDataListCentroCustos($event.target.value)" maxlength="40" 
                    [ngClass]="{'h-error' : this.form.get('centroCustoId').hasError('isNotValidCentroCusto')}" />
                  <div class="input-group-append cp" (click)="limparDataListCentroCustos()"
                    title="limpar campo e recarregar lista de opções">
                    <span class="input-group-text"><i class="fa fa-trash"></i></span>
                  </div>
                  

                </div>
                <small *ngIf="form.get('centroCustoId').hasError('isNotValidCentroCusto')" class="form-text text-danger pl-2">
                  O valor deve ser informado
                </small>

              </div>

            </div>
            <div class="col-md-1"></div>

            <div class="col-md-6">
              <div class="position-relative form-group">
                <label for="localizacao">Localização<span *ngIf="this.requeridoLocalizacao"
                    class="field-required">(*)</span></label>
                <input class="form-control" formControlName="localizacao" type="text" maxlength="40" value="" 
                  [ngClass]="{'h-error' : this.form.get('localizacao').hasError('isNotValidLocalizacao')}">
                <small *ngIf="form.get('localizacao').hasError('isNotValidLocalizacao')" class="form-text text-danger pl-2">
                  A localização deve ser informada
                </small>

              </div>


            </div>



          </div>

          <section style="border: 1px solid #ddd;" *ngIf="this.autorizacaoAdicionarFoto">
            <div class="form-row text-center" style="padding: 0 5px;">
              <div class="col-md-11 fb fs11" style="background-color: #eee; padding: 12px">
                <i *ngIf="this.isLoadingRegistroFotografico" class="fa fa-spinner fa-spin fa-fw pull-left"></i>
                Registro fotográfico
              </div>
              <div class="col-md-1 bg-primary cp" style="padding: 12px" title="Adicionar Registro Fotográfico"
                (click)="fileInput.click()">
                <span><i class="fwn fa fa-plus"></i></span>
              </div>

            </div>

            <div class="row showImagens" style="padding-bottom: 20px; min-height: 150px;">
              <div class="col-md-2" *ngFor="let pview of previewsPhotos">
                <div>
                  <img [src]="pview.dataUrl" class="zoom cp" (click)="openModalExibePhoto(modalExibePhoto, pview)">
                  <button type="button" class="btn btn-default">
                    <i class="fa fa-trash text-secoundary" (click)="removerPhoto(pview.name)"
                      title="Remover esta foto"></i>
                  </button>
                </div>
              </div>
            </div>

          </section>

          <div class="divider"></div>

          <div class="form-row ">
            <div class="col">
              <div class="d-flex justify-content-end">

                <app-ball-pulse *ngIf="isSalvando"></app-ball-pulse>

                <button class="mr-2 btn btn-lg btn-outline-primary" (click)="reset()" type="button"><i
                    class="mr-2 fa fa-trash"></i>Limpar<span class="mr-2"></span></button>
                <button class="btn btn-lg btn-shadow"
                  [disabled]="(!(this.isNovoCadastro && this.autorizacoes?.podeIncluir) && !(!this.isNovoCadastro && this.autorizacoes?.podeAlterar)) || this.isSalvando"
                  [ngClass]="{ 'btn-primary' : isNovoCadastro, 'btn-warning' : !isNovoCadastro }" type="submit">
                  <i class="fa mr-3" [ngClass]="{'fa-plus' : isNovoCadastro, 'fa-edit' : !isNovoCadastro}"></i>
                  {{ isNovoCadastro ? 'Cadastrar' : 'Editar' }} <i class="mr-2">&nbsp;</i>
                </button>
              </div>
            </div>

          </div>


        </form>

        <form hidden novalidate [formGroup]="photoForm">
          <input #fileInput formControlName="photo" type="file" accept="image/*" multiple
            (change)="handleFile($event.target.files)">
        </form>



      </div>
    </div>
  </div>
</div>



<ng-template #modalExibePhoto let-c="close" let-d="dismiss">
  <div class="modal-body" style="padding: 0px; background-color: #141518;">
    <div class="row">
      <div class="col-md-12 text-center" style="padding:10px; background: #141518 ;">
        <img [src]="previewPhotoSelecionada.dataUrl" class="img-thumbnail">
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12" style="padding:10px; background: #141518 ;">
      <div class="text-right">
        <button type="button" class="btn btn-secondary pl-5 pr-5 mr-4" (click)="c('Close click')">Fechar</button>
      </div>
    </div>
  </div>
</ng-template>